// its middlewear to handle reducer call to update a state

import { getData, postData } from "../../../backend/api";

const fetchLogin = (data) => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_USER_LOGIN_LOADING",
    });
    return postData(data, "user/validate")
      .then((response) => {
        if (response.status === 200) {

          // ✅ STORE TOKEN FIRST
          sessionStorage.setItem("token", response.data.token);

          dispatch({
            type: "FETCH_USER_LOGIN_SUCCESS",
            payload: response.data,
          });

          let currentMenu = response.data.menu[0];

          dispatch({ type: "MENU_STATUS", payload: false });
          dispatch({ type: "SELECTED_MENU", payload: currentMenu });
          dispatch({ type: "CURRENT_MENU", payload: currentMenu.label });

          return response.data;
        } else {
          dispatch({ type: "FETCH_USER_LOGIN_ERROR", payload: "validationFailed" });
        }
      }).catch((error) => {
        dispatch({
          type: "FETCH_USER_LOGIN_ERROR",
          payload: "validationFailed",
        });
      });
  };
};

const fetchUserMenu = (data = {}) => {
  return (dispatch) => {
    dispatch({ type: "FETCH_USER_LOGIN_LOADING" });

    return getData(data, "user/menu").then((response) => {
      if (response.status === 200) {
        dispatch({
          type: "FETCH_USER_LOGIN_SUCCESS",
          payload: response.data,
        });

        let currentMenu = response.data.menu[0];
          dispatch({
            type: "MENU_STATUS",
            payload: false,
          });
          dispatch({
            type: "SELECTED_MENU",
            payload: currentMenu,
          });
          dispatch({
            type: "CURRENT_MENU",
            payload: currentMenu.label,
          });

        return response.data;   // ⭐ return data!
      }
    });
  };
};


const fetchCompanyMenu = (data) => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_USER_LOGIN_LOADING",
    });

    return getData(data, "user/company/menu")
      .then((response) => {
        if (response.status === 200) {
          sessionStorage.setItem("selected-company", data.company);
          dispatch({
            type: "FETCH_USER_LOGIN_SUCCESS",
            payload: response.data,
          });

          let currentMenu = response.data.menu[0];
          dispatch({
            type: "MENU_STATUS",
            payload: false,
          });
          dispatch({
            type: "SELECTED_MENU",
            payload: currentMenu,
          });
          dispatch({
            type: "CURRENT_MENU",
            payload: currentMenu.label,
          });
          
          return response.data;
      }});
  };
};

const clearLogin = () => {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_USER_LOGIN",
    });
  };
};
const clearLoginSession = () => {
  return (dispatch) => {
    dispatch({
      type: "CLEAR_USER_LOGIN_SESSION",
    });
  };
};
const udpateLogin = (data) => {
  return (dispatch) => {
    dispatch({
      type: "FETCH_USER_LOGIN_SUCCESS",
      payload: data,
    });
  };
};
export { fetchLogin, fetchUserMenu, fetchCompanyMenu, clearLogin, clearLoginSession, udpateLogin };
